import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

function CommitFinishModal({ action, ecosystem, success, onClose, requestID }) {
  const successMsg = `Your ecosystem has been successfully ${action === 'Commit' ? 'committed' : 'reverted'}`;
  const failedMsg = `Your ecosystem refused to ${action.toLowerCase()} recent changes`;
  const failedReason = `Please review the configuration of networks or prefixes`;

  return (
    <div className="commit-finish">
      <div className="commit-result">
        <p className="result-header">{success ? successMsg : failedMsg}</p>
        <div className="result-body">
          <p>Ecosystem Name: {ecosystem.name}</p>
          <p>Ecosystem UUID: {ecosystem.uuid}</p>
          <p>Request-ID: {requestID}</p>
          {!success && <p>Reason: {failedReason}</p>}
        </div>
      </div>
      <div className="wedge-modal__footer">
        <Button variant="contained" sx={{ fontSize: 14, width: 100 }} size="large" onClick={onClose}>
          OK
        </Button>
      </div>
    </div>
  );
}

CommitFinishModal.propTypes = {
  ecosystem: PropTypes.object,
  success: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  requestID: PropTypes.string,
  action: PropTypes.string.isRequired,
};

export default CommitFinishModal;
